// eslint-disable-next-line import/prefer-default-export
import { thumborDomainUrl } from 'store/constant';

export const capitalizeString = (string, splittingSymbol = '') => {
    if (string) {
        return string
            .split(splittingSymbol)
            .map((str) => str.charAt(0).toUpperCase() + str.slice(1))
            .join(' ');
    }
    return '';
};

export const thumborImageUrl = (imageUrl = '', height, width) => {
    if (!imageUrl) return '';
    if (window.location.origin.indexOf('localhost') > 0 || imageUrl.indexOf('localhost') > 0) return imageUrl;
    const thumborUrl = `${thumborDomainUrl}${height}x${width}/smart/`;
    let newUrl = `${thumborUrl}${imageUrl}`;
    if (imageUrl.indexOf('http') < 0 || imageUrl.includes('travclan-logo')) {
        newUrl = `${thumborUrl}${window.location.origin || 'https://travclan.com'}${imageUrl}`;
    }
    return newUrl;
};

export const getFileNameFromUrl = (url = '') => {
    if (!url || typeof url !== 'string') return '';
    return url.substring(url.lastIndexOf('/') + 1).split('?')[0];
};
